var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"text-gray-700 text-3xl font-medium"},[_vm._v("Blank Page")]),_vm._v(" "+_vm._s(_vm.test)+" "),_c('span',[_vm._v("count: "+_vm._s(_vm.count))])])}
var staticRenderFns = []

export { render, staticRenderFns }